import Spinner from '../Spinner/Spinner';
import { Items, MenuProps } from './Types';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import { CheckIcon } from '@heroicons/react/20/solid';
import { cn } from '../../utils';

export function Menu<T extends Items = Items>({
    filteredItems,
    toggleSelectItem,
    isSelected,
    doubleLine,
    textVariant,
    leadingIcon,
    loading,
}: MenuProps<T>) {
    if (loading) {
        return (
            <div className="alli-flex alli-w-full alli-items-center alli-justify-center alli-px-4 alli-py-2">
                <Spinner />
            </div>
        );
    }

    if (!filteredItems?.length) {
        return (
            <div className="alli-flex alli-w-full alli-items-center alli-px-4 alli-py-2 alli-text-sm alli-font-normal alli-text-blue-gray-600">
                No Results Found
            </div>
        );
    }

    const renderItemIcon = (item: T) => (
        <div
            className="alli-h-5 alli-w-5 alli-flex-shrink-0 alli-text-gray-700"
            aria-hidden="true">
            {item?.icon ? item.icon : <UserCircleIcon />}
        </div>
    );

    const renderItemText = (item: T) => (
        <div
            className={cn(
                'alli-flex alli-w-full alli-flex-col alli-overflow-hidden',
                textVariant === 'secondary' &&
                    'alli-flex-row alli-items-center alli-gap-2',
            )}>
            <div
                title={item.title}
                className={cn(
                    'alli-overflow-hidden alli-text-ellipsis alli-whitespace-nowrap alli-text-blue-gray-700',
                    doubleLine && 'alli-font-medium',
                )}>
                {item.title}
            </div>
            {doubleLine && (
                <div
                    title={`${item?.id}`}
                    className="alli-overflow-hidden alli-text-ellipsis alli-whitespace-nowrap alli-text-xs alli-font-normal alli-text-gray-700">
                    {item?.id}
                </div>
            )}
        </div>
    );

    return (
        <>
            {filteredItems.map((item, index) => (
                <div
                    key={index}
                    onClick={() => toggleSelectItem(item)}
                    className={cn(
                        'alli-flex alli-w-full alli-cursor-pointer alli-items-center alli-justify-between alli-px-4 alli-py-2 alli-text-sm alli-font-normal hover:alli-bg-gray-100',
                        isSelected(item) && 'alli-bg-gray-100 alli-font-medium',
                    )}>
                    <div className="alli-flex alli-w-full alli-items-center alli-gap-3">
                        {leadingIcon &&
                            item.title !== 'Select All/Unselect All' &&
                            renderItemIcon(item)}
                        {renderItemText(item)}
                        {isSelected(item) && (
                            <CheckIcon className="alli-h-5 alli-w-5 alli-flex-shrink-0 alli-stroke-2 alli-text-blue-600" />
                        )}
                    </div>
                </div>
            ))}
        </>
    );
}
